import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import logo2 from "../../assets/img/logo_macizo1.png";
import PropTypes from "prop-types";
import { getUser } from "../../setup/users/actions.js";
import Cover from "react-video-cover";
import vid from "../../assets/img/video.mp4";
import "./design.css";
import Swal from 'sweetalert2';  // Importa SweetAlert2
import Loading from "../../views/Loading.jsx"
import { dominio } from "../../routes_backend/routes.jsx";


class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identifier: "",
      errors: {},
      isLoading: false,
      available: "",
      message: "",
      username: '',
      password: '',
      error: ''
    };

  }

  
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;

    this.setState({
      isLoading: true,
    });
  
    try {
      const response = await fetch(`${dominio}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
  
      let TOKEN = '';
      if (response.status === 200) {
        const data = await response.json();
        console.log('Token de sesión:', data);
        TOKEN = data.session_token;
  
        const res = fetch(`${dominio}/getUsersLogin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username, password }),
        });
  
        res
          .then(async (res) => {
            const data2 = await res.json();
            // console.log(data2);
            let temp_Data = [];
            data2.forEach((element) => {
              let obj = {
                UserId: " ",
                U_UserId: element.U_UserId,
                Nombre: element.U_Nombre,
                Apellido: element.U_Apellido,
                email: element.U_email,
                Cargo: element.U_Cargo,
                is_available: element.U_is_available,
                GrpReporte: element.U_GrpReporte,
                RepId: element.U_RepId,
                CargoOrda: element.U_CargoOrda,
                UserCode: element.U_UserCode,
                usuarioSAP: username,
                contraseñaSAP: password,
              };
              temp_Data.push(obj);
              console.log(temp_Data);
            });
  
            // Actualizar el estado y luego realizar acciones adicionales
            this.setState({
              message: '',
              isLoading: false,
              data2: temp_Data,
              data_search: data2,
              dataUsuarios: temp_Data,
            }, () => {
              // Ahora que el estado se ha actualizado, puedes usar dataUsuarios dentro del bloque if
              // console.log(this.state.dataUsuarios);
  
              // if (password === "4jXMwn" && username === "manager") {
              //   // Utilizar dataUsuarios dentro del bloque if
              //   console.log(this.state.dataUsuarios);
  
              //   const dataT = [
              //               {
              //                 UserId: " ",
              //                 Nombre: "admin",
              //                 Apellido: "admin",
              //                 email: "admin",
              //                 Cargo: "admin",
              //                 Password: "admin",
              //                 is_available: "1",
              //                 GrpReporte: "[ 1 ]",
              //                 RepId: "[1001,1002,1003,1004,1005,1006,1007]",
              //                 CargoOrda: 1,
              //                 UserCode: 0,
              //                 usuarioSAP: username,
              //                 contraseñaSAP: password,
              //                 user_code: data.user_code,
              //                 user_id: data.user_id
              //               },
              //             ];
  
              //   localStorage.setItem('TOKEN', TOKEN);
              //   localStorage.setItem("token", JSON.stringify(this.state.dataUsuarios));
  
              //   this.props.history.push("/home");
              // }
               localStorage.setItem('TOKEN', TOKEN);
                localStorage.setItem("token", JSON.stringify(this.state.dataUsuarios));
  
                this.props.history.push("/home");
            });
  
          })
          .catch((error) => {
            console.log(error);
            this.setState({
              isLoading: false,
              message: 'error in the server'
            });
          });
  
      } else {

        // alert('Credenciales incorrectas');
        // this.setState({ error: 'Credenciales incorrectas' });
        const errorMessage = this.setState({ error: 'Credenciales incorrectas' });


        Swal.fire({
          icon: 'error',
          title: 'Credenciales incorrectas',
          text: errorMessage || 'Verifique Usuario y Contraseña'
        }).then(() => {
          window.location.reload();
        });


      }
    } catch (error) {

      // alert('Error al enviar la solicitud:');
      // console.error('Error al enviar la solicitud:', error);

      const errorMessage = this.setState({ error: 'Verifique Conexion al Servidor' });


      Swal.fire({
        icon: 'error',
        title: 'Fallo al Iniciar Sesion',
        text: errorMessage || 'Verifique la conexion con el servidor'
      }).then(() => {
        // window.location.reload();
        this.props.history.push("/home");
      });
    }
  }
  


  render() {

    const {     
      isLoading,
    } = this.state;
    const imgStyle = {
      width: "50%",
      marginLeft: "25%",
    };

    const {
      errors,
    } = this.state;
    const videoOptions = {
      src: vid,
      autoPlay: true,
      muted: true,
      loop: true,
    };
    return (
      
      <div responsive="true">
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/sweetalert2@11"></link>

        <div style={styles.style} responsive="true">
          <Cover
            videoOptions={videoOptions}
            remeasureOnWindowResize
            getResizeNotifier={(resizeNotifier) => {
              this.setState({
                resizeNotifier,
              });
            }}
          />
        </div>
        <div
          style={
            document.documentElement.clientWidth > 900
              ? styles.sectionStyle
              : styles.resize
          }
        >
          <div id="text" className="text">
            {/* <h1>Macizo</h1> */}
          </div>
          <div className="col-md-10">
            <div className="content" style={styles.fondo}>
              <Grid>
                <Row>
                  <Col md={6}>
                    <div
                      className="jumbotron jumbotron-fluid"
                      style={styles.jumboStyle}
                    >
                      <div className="jumbotron" style={styles.jumboStyle}>
                        <form onSubmit={this.handleSubmit}>
                          <div className="logo-img" style={{ opacity: 0.6 }}>
                            <img
                              style={imgStyle}
                              src={logo2}
                              alt="logo_image"
                            />
                          </div>
                          <h1
                            align="center"
                            className="display-4"
                            style={{ color: "white" }}
                          >
                            Login
                          </h1>

                          {errors.form && (
                            <div className="alert alert-danger">
                              {errors.form}
                            </div>
                          )}
                          <div>
                            <label className="labelLogin">Nombre de Usuario:</label>
                            <input
                              type="text"
                              name="username"
                              value={this.state.username}
                              onChange={this.handleInputChange}
                            />
                          </div>
                          <div>
                            <label className="labelLogin">Contraseña:</label>
                            <input
                              type="password"
                              name="password"
                              value={this.state.password}
                              onChange={this.handleInputChange}
                            />
                          </div>
                          <p
                            style={{
                              height: "100px",
                              fontSize: "16px",
                              color: "#B43B22",
                            }}
                          >
                            <strong>{this.state.message} </strong>
                          </p>
                          <div className="form-group" align="center">
                        
                            <button type="submit">Iniciar Sesión</button>
                          </div>
                        </form>
                        <p
                          onClick={this.handlerForgotPassword}
                          style={styles.styleForgotMessage}
                        >
                        </p>
                      </div>
                      <footer
                        style={{ backgroundColor: "rgba(0,0,0,0)" }}
                        className="footer"
                      >
                        <Grid fluid>
                          <p
                            style={{ color: "white" }}
                            className="copyright pull-right"
                          >
                            &copy; {new Date().getFullYear()} Created by&nbsp;
                            <a href="http://macizo.com.gt"> Macizo</a>
                          </p>
                        </Grid>
                      </footer>
                    </div>
                  </Col>
                </Row>
              </Grid>
              {isLoading && <Loading />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginForm.protoTypes = {
  getUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

LoginForm.contextTypes = {};

function mapStateToProps(state) {
  return {
    user: state.user.user,
  };
}

export default connect(mapStateToProps, { getUser })(LoginForm);

const styles = {
  fondo: {
    alignItems: "left",
  },
  jumboStyle: {
    width: "100%",
    height: "100%",

    background: "linear-gradient(to right bottom, rgb(0 0 0 / 50%), rgba(0, 78, 146, 0.05))"
  },
  
  style: {
    backgroundSize: "cover",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    botttom: 0,
    zIndex: 0,
  },
  sectionStyle: {
    position: "absolute", //'fixed',
    top: 0,
    left: 0,
    right: 0,
    botttom: 0,
    padding: "2.5%",
    background:
      "linear-gradient(to right bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
    zIndex: 2,
  },
  resize: {
    position: "absolute",
    padding: "2.5%",
    background:
      "linear-gradient(to right bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
    zIndex: 2,
  },
  styleForgotMessage: {
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#FEFEFE",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
